<a #anchor (click)="toggle()"><ng-content select="popoverLink"></ng-content></a>
@if (show()) {
  <kendo-popup #popup [anchor]="anchor" popupClass="content">
    <ng-content select="popoverContent"></ng-content>
  </kendo-popup>
}
